import { useContext } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import FormHeader from "../components/FormHeader";
import LanguageSwitcher from "../components/LanguageSwitcher";
import AppConfigContext from "../context/AppConfigContext";
import { getProgramTypeFromSubdomain, getStateFromSubdomain } from "../utils/utils";
import { PROGRAM_TYPE } from "../utils/constants";
import styles from "./FormLayout.module.scss";

const FormLayout = () => {
    const state = getStateFromSubdomain();
    // The C-SNP copy variant is English only (Shaun, 2026-09-28), so the switcher is hidden on that host.
    const englishOnly = getProgramTypeFromSubdomain() === PROGRAM_TYPE.CSNP;

    const { config } = useContext(AppConfigContext);

    const customFooter = config.footer?.customFooter;
    let CustomFooter = null;
    if (customFooter?.enabled) {
        CustomFooter = customFooter.component;
    }

    return (
        <>
            {config.isMultiLingual && !config.hideLanguageSwitcher && !englishOnly && (
                <div className={`${styles.langSwitcher} container pt-3 d-flex justify-content-end`}>
                    <LanguageSwitcher />
                </div>
            )}
            <FormHeader state={state} />
            <main className="flex-grow-1">
                <Outlet />
            </main>
            {config.footer?.customFooter?.enabled ? <CustomFooter /> : <Footer nav={false} state={state} />}
        </>
    );
};

export default FormLayout;
